// extracted by mini-css-extract-plugin
export var content = "_do-3";
export var list = "_do-4";
export var settingsContent = "_do-7";
export var settingsPanel = "_do-8";
export var state = "_do-6";
export var triggerBadge = "_do-2";
export var triggerButton = "_do-1";
export var triggerShell = "_do-0";
export var unreadDot = "_do-5";